import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './evaluacionMonitoreo.css';

  const EvaluacionMonitoreo = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
            <div className='ldf_titulo'>
                <h2>Evaluación y Monitoreo a Programas</h2>
                <hr className='hr-gob'/>
            </div>

            <table className="table table-striped table-bordered tabla_elementos">
                <tbody>
                    <tr>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2017">2017</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2018">2018</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2019">2019</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2020">2020</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2021">2021</Link></h3></td>
                    </tr>
                    <tr>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2022">2022</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2023">2023</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2024">2024</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2025">2025</Link></h3></td>
                        <td><h3><Link to="DetalleEvaluacionMonitoreo/DetalleEvaluacionMonitoreo2026">2026</Link></h3></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
         </div>
     </div>
     )
}

export default EvaluacionMonitoreo